"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hasSize(input) {
    return input != null && input.size !== undefined;
}
exports.hasSize = hasSize;
//# sourceMappingURL=HasSize.js.map